import { Box, Card, Stack, Typography } from "@mui/material";
import { allColors } from "../../constants";

const stepColor = {
    "01": {
        backgroundColor: "#FEF4DA",
        color: "#F3B11C",
    },
    "02": {
        backgroundColor: "#F0E2FF",
        color: "#6D00E2",
    },
    "03": {
        backgroundColor: "#E4F8FF",
        color: "#00BCFF",
    },

}
const ProcessCard = ({ step, title, description, image }) => {
    return (
        <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" gap={2}>
            <Box
                sx={{
                    width: { xs: 48, md: 54 },
                    height: { xs: 48, md: 54 },
                    borderRadius: "999px",
                    backgroundColor: stepColor[step].backgroundColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: stepColor[step].color,
                    fontWeight: 700,
                    fontSize: { xs: "20px", md: "22px" },
                    flexShrink: 0,
                    ml: 0,
                }}
            >
                {step}
            </Box>

            <Card
                sx={{
                    boxShadow: "none",
                    borderRadius: "20px",
                    border: "1px solid #EAEAEA",
                    px: { xs: 2, sm: 2, md: 2.5 },
                    py: { xs: 2 },
                    width: "100%",
                    overflow: "hidden",
                }}
            >
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    gap={{ xs: 2, md: 3 }}
                    sx={{ width: "100%" }}
                >
                    {/* <Box
                    sx={{
                        width: { xs: 48, md: 54 },
                        height: { xs: 48, md: 54 },
                        borderRadius: "999px",
                        backgroundColor: stepColor[step].backgroundColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: stepColor[step].color,
                        fontWeight: 700,
                        fontSize: { xs: "20px", md: "22px" },
                        flexShrink: 0,
                        ml: 0,
                    }}
                >
                    {step}
                </Box> */}

                    <Box flex={1} minWidth={0}>
                        <Typography color="text.secondary" fontSize={{ xs: "12px", md: "14px" }} mb={0.5}>
                            Step {step}
                        </Typography>
                        <Typography
                            color={allColors.jetBlack}
                            fontWeight={500}
                                fontSize={{ xs: "20px", md: "24px" }}
                            lineHeight={1.2}
                            mb={1}
                        >
                            {title}
                        </Typography>
                        <Typography color="#5F5F5F" fontSize={{ xs: "12px", md: "14px" }} lineHeight={1.5}>
                            {description}
                        </Typography>
                    </Box>

                    <Box
                        component="img"
                        src={image}
                        alt={title}
                        sx={{
                            width: { xs: "100%", sm: 200, md: 250, lg: 300 },
                            maxWidth: "100%",
                            borderRadius: "12px",
                            objectFit: "cover",
                            alignSelf: { xs: "stretch", sm: "center" },
                            flexShrink: 0,
                        }}
                    />
                </Stack>
            </Card>
        </Stack>
    );
};

export default ProcessCard;